/**
 * Created by contrapro on 03/04/2018
 */

import {
    ACTION_TYPE_UPDATE_LOCAL_USER,
} from '../actions';

// import { hpToLevel} from '../util/constConfig';

const initialState = {
    objectId: '',
    unionid: '',
    openid: '',
    crmMemberId: '',
    nickname:'',
    avatar: '',
    freeSeed:0, //免费种子数
    welcomeOK:false,
    firstWaterOK: false,

    point:0, //互动积分 social point

    scene:'farm',

    todayWxShareNum: 0,
    todayWxMGMNum: 0,

};

export default function userReducer(state = initialState, action) {
    //console.log(action);
    switch (action.type) {

        case ACTION_TYPE_UPDATE_LOCAL_USER:
            console.log('ACTION_TYPE_UPDATE_LOCAL_USER',{ ...action.payload.data });

            return {
                ...state,
                ...action.payload.data,
            };

        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js